import { useT } from "../../../i18n/LanguageContext";
import { CLIENTS } from "../../../data/clients";
import "./ClientsContent.css";

export function ClientsContent() {
	const { t } = useT();

	return (
		<div className="clientsContent">
			<p className="clientsContent_title" data-reveal="rise">
				{t("clients.title")}
			</p>
			<ul className="clientsContent_logos">
				{CLIENTS.map((client, i) => {
					const logo = (
						<img
							src={client.logo}
							alt={client.name.trim()}
							className="clientsContent_logo"
							draggable="false"
							loading="lazy"
						/>
					);
					return (
						<li key={client.name} data-reveal="rise" style={{ "--d": i + 1 }}>
							{client.href ? (
								<a href={client.href} target="_blank" rel="noreferrer noopener">
									{logo}
								</a>
							) : (
								logo
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
}
